<template>
  <div class="fill-height">
    <stat-card
      v-if="large"
      class="fill-height"
      :title="title"
      :value="value"
      :max="max"
      :color="color"
      :loading="loading"
    />
    <v-card
      v-else
      class="rounded-lg fill-height align-center"
    >
      <v-card-title class="pa-4 fill-height d-flex align-center justify-space-between">
        <div
          class="text-subtitle-2"
          style="max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >
          {{ title }}
        </div>
        <div class="grey--text">
          {{ value ? value : 'N/A' }}
        </div>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import StatCard from '@/components/StatCard.vue'
import { getColorForValue } from '@/utils/helpers'

export default {
  name: 'PerformanceStatCard',
  components: {
    StatCard
  },
  props: {
    large: {
      type: Boolean,
      default: false
    },
    variableKey: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    reversed: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    color() {
      return getColorForValue(this.value, this.max, this.reversed)
    }
  }
}
</script>
